import { useQuery } from '@apollo/client';

export const useBackgroundQuery = (query, options) =>
  useQuery(query, {
    ...options,
    context: {
      backgroundLoading: true,
      ignoreCache: true
    }
  });
